import { render, staticRenderFns } from "./GCheckboxWorkFormInput.vue?vue&type=template&id=47b8b118&scoped=true&"
import script from "./GCheckboxWorkFormInput.vue?vue&type=script&lang=ts&"
export * from "./GCheckboxWorkFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GCheckboxWorkFormInput.vue?vue&type=style&index=0&id=47b8b118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8b118",
  null
  
)

export default component.exports